import { uploadFile } from '../api/endpoints/media';
import { API_URL } from '../utils/url';

class CustomUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    const file = await this.loader.file;
    const res = await uploadFile(file);
    const url = res.data.data.url;
    return { default: url.startsWith('http') ? url : (API_URL?.API_BASE_URL || '') + url };
  }

  abort() {}
}

export default function UploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new CustomUploadAdapter(loader);
  };
}
